import type { IApplicationState } from 'shared/types/redux';
import { IDeveloperFactWebSchema } from 'shared/repositories/special-promos/entities/developer_fact_web/DeveloperFactWebSchema';

export function developerFactsSelector(state: IApplicationState): IDeveloperFactWebSchema[] {
  return state.specialPromosBlocks.facts;
}
